import React from "react"
import { Grid, Typography, Tooltip } from "@material-ui/core"
import { ChevronRight as ChevronRightIcon, BookCopy as BookCopyIcon } from "lucide-react"
import clsx from "clsx"

import InstanceSelectorDialogue from "@/components/InstanceSelectorDialogue"
import { useGlobalStateStore } from "@/store/GlobalState"
import useStyles from "@/@integrations/Whatsapp/components/Menu/NewSideBar/InstanceSelectorItem/styles"

type InstanceSelectorItemProps = {
	isSidebarOpen: boolean
}

const InstanceSelectorItem: React.FC<InstanceSelectorItemProps> = ({ isSidebarOpen }) => {
	const classes = useStyles()
	const globalStateStore = useGlobalStateStore()

	const instanceId = globalStateStore.instance.instance_id
	const instanceName = globalStateStore.instance.nickname ?? `Instância ${instanceId}`

	const handleOpen = () => {
		InstanceSelectorDialogue.open({
			actualUserInstanceId: instanceId,
			allUserInstances: globalStateStore.user.user_instances,
			isAdminView: globalStateStore?.user?.extra_data?.is_admin_mode
		})
	}

	if (!isSidebarOpen) {
		return (
			<Tooltip title={instanceName} placement="right">
				<Grid
					container
					wrap="nowrap"
					alignItems="center"
					className={clsx(classes.card, classes.cardCollapsed)}
					style={{ width: "fit-content" }}
					onClick={handleOpen}
				>
					<Grid item>
						<Grid container alignItems="center" justifyContent="center" className={classes.iconBox}>
							<BookCopyIcon size={14} />
						</Grid>
					</Grid>
				</Grid>
			</Tooltip>
		)
	}

	return (
		<Grid
			container
			wrap="nowrap"
			alignItems="center"
			className={classes.card}
			style={{ width: "auto" }}
			onClick={handleOpen}
		>
			<Grid item>
				<Grid container alignItems="center" justifyContent="center" className={classes.iconBox}>
					<BookCopyIcon size={14} />
				</Grid>
			</Grid>

			<Grid item className={classes.textContainer}>
				<Typography className={classes.instanceIdText}>
					Instância atual: {instanceId}
				</Typography>
				<Typography className={classes.instanceNameText}>
					{instanceName}
				</Typography>
			</Grid>

			<Grid item>
				<Grid container alignItems="center">
					<ChevronRightIcon size={16} className={classes.chevron} />
				</Grid>
			</Grid>
		</Grid>
	)
}

export default InstanceSelectorItem
